$(document).ready(function() {
    const $sliders = {
        howItWorks: $('.how-it-works__items'),
        buyWithConfidence: $('.bwc__items'),
        bankOptions: $('.bank-options__items')
    };

    if ($sliders.howItWorks.length > 0) {
        $sliders.howItWorks.slick({
            dots: false,
            centerMode: false,
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: false,
            arrows: false,
            responsive: [
                {
                    breakpoint: 750,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true,
                        centerMode: true,
                        centerPadding: '35px'
                    }
                }
            ]
        });
    }

    if ($sliders.buyWithConfidence.length > 0) {
        $sliders.buyWithConfidence.slick({
            dots: false,
            centerMode: false,
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: false,
            arrows: false,
            responsive: [
                {
                    breakpoint: 750,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true,
                        centerMode: true,
                        centerPadding: '45px'
                    }
                }
            ]
        });
    }

    if ($sliders.bankOptions.length > 0) {
        $sliders.bankOptions.slick({
            dots: false,
            centerMode: false,
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: false,
            arrows: false,
            responsive: [
                {
                    breakpoint: 750,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true,
                        centerMode: true,
                        centerPadding: '45px'
                    }
                }
            ]
        });
    }
});